import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import Multilingual from '~~utils/Multilingual';
import { SeasonResource } from '~~apis/resource';
import { SectionDiv, StyledForm } from '../styled';
import { useTournamentDispatch, useTournamentState } from '../useTournament';

const Stats = ({ tournament }) => {
  const tournamentDispatch = useTournamentDispatch();
  const { organizerUniqid } = useTournamentState();
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [configData, setConfigData] = useState(null);

  useEffect(() => {
    setConfigData({
      ...JSON.parse(JSON.stringify(tournament)).config,
    });
  }, [tournament]);

  const handleWeightOnChange = (e) => {
    setErrorMsg('');
    setSuccessMsg('');
    setConfigData({
      ...configData,
      leader_board_config: {
        ...configData.leader_board_config,
        [e.target.name]: e.target.value,
      },
    });
  };

  const handleStandingPointOnChange = (e) => {
    setErrorMsg('');
    setSuccessMsg('');
    setConfigData({
      ...configData,
      standing_point_config: {
        ...configData.standing_point_config,
        [e.target.name]: e.target.value,
      },
    });
  };

  const handleLeaderboardOpen = () => {
    setConfigData({
      ...configData,
      open_leader_board: !configData.open_leader_board,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    const PA_weight = parseFloat(configData.leader_board_config.PA_weight);
    const IP_weight = parseFloat(configData.leader_board_config.IP_weight);
    for (let weight of [PA_weight, IP_weight]) {
      if (Number.isNaN(weight)) {
        setErrorMsg(Multilingual(`TOURNAMENT.ERROR.LEADERBOARD_WEIGHT`));
        return;
      }
    }

    const standingPoint = {
      win: parseInt(configData.standing_point_config.win),
      draw: parseInt(configData.standing_point_config.draw),
      lose: parseInt(configData.standing_point_config.lose),
      forfeited_lose: parseInt(configData.standing_point_config.forfeited_lose),
      adjudged_lose: parseInt(configData.standing_point_config.adjudged_lose),
    };
    for (let point of Object.values(standingPoint)) {
      if (Number.isNaN(point)) {
        setErrorMsg(Multilingual(`TOURNAMENT.ERROR.ROUND_ROBIN_POINT`));
        return;
      }
    }

    SeasonResource.updateSeason({
      leagueUniqid: organizerUniqid,
      seasonUniqid: tournament.uniqid,
      data: {
        ...tournament,
        start_at: moment(tournament.start_at).format('YYYY/MM/DD'),
        end_at: moment(tournament.end_at).isValid() ? moment(tournament.end_at).format('YYYY/MM/DD') : '',
        config: {
          ...configData,
          leader_board_config: {
            ...configData.leader_board_config,
            PA_weight,
            IP_weight,
          },
          standing_point_config: {
            ...standingPoint,
          },
        },
      },
    })
      .then(({ data }) => {
        tournamentDispatch({ type: 'SET_TOURNAMENT_INFO', payload: data });
        setSuccessMsg(Multilingual(`TOURNAMENT.SUCCESS.UPDATE`));
      })
      .catch((e) => {
        console.log(e);
        setErrorMsg(Multilingual(`TOURNAMENT.ERROR.UNKNOWN`));
      });
  };

  if (!configData) {
    return <SectionDiv></SectionDiv>;
  }

  return (
    <SectionDiv>
      <StyledForm onSubmit={handleSubmit}>
        <div className="box">
          {/* 排行榜 */}
          <label>{Multilingual('TOURNAMENT.LEADERBOARD')}</label>
          <label>{Multilingual('TOURNAMENT.PAWeight')}</label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder={Multilingual('TOURNAMENT.PAWeight')}
                name="PA_weight"
                value={configData.leader_board_config.PA_weight}
                onChange={handleWeightOnChange}
              />
            </div>
          </div>
          <label>{Multilingual('TOURNAMENT.IPWeight')}</label>
          <div className="input-field">
            <div className="input-box">
              <Input
                width="100%"
                placeholder={Multilingual('TOURNAMENT.IPWeight')}
                name="IP_weight"
                value={configData.leader_board_config.IP_weight}
                onChange={handleWeightOnChange}
              />
            </div>
          </div>
          <label>
            <input type="checkbox" checked={configData.open_leader_board} onChange={handleLeaderboardOpen} />
            {Multilingual('TOURNAMENT.OPEN_LEADERBOARD')}
          </label>
          <div className="input-field" />
          {/* 循環賽積分 */}
          <label>{Multilingual('TOURNAMENT.ROUND_ROBIN_POINT')}</label>
          <div className="input-field">
            <label>{Multilingual('GAME.MATCH_RESULT.WIN')}</label>
            <Input
              width="auto"
              placeholder=""
              name="win"
              value={configData.standing_point_config.win}
              onChange={handleStandingPointOnChange}
            />
          </div>
          <div className="input-field">
            <label>{Multilingual('GAME.MATCH_RESULT.DRAW')}</label>
            <Input
              width="auto"
              placeholder=""
              name="draw"
              value={configData.standing_point_config.draw}
              onChange={handleStandingPointOnChange}
            />
          </div>
          <div className="input-field">
            <label>{Multilingual('GAME.MATCH_RESULT.LOSE')}</label>
            <Input
              width="auto"
              placeholder=""
              name="lose"
              value={configData.standing_point_config.lose}
              onChange={handleStandingPointOnChange}
            />
          </div>
          <div className="input-field">
            <label>{`${Multilingual('GAME.FINISHED_STATUS.FORFEITED')} ${Multilingual(
              'GAME.MATCH_RESULT.LOSE',
            )}`}</label>
            <Input
              width="auto"
              placeholder=""
              name="forfeited_lose"
              value={configData.standing_point_config.forfeited_lose}
              onChange={handleStandingPointOnChange}
            />
          </div>
          <div className="input-field">
            <label>{`${Multilingual('GAME.FINISHED_STATUS.ADJUDGED')} ${Multilingual(
              'GAME.MATCH_RESULT.LOSE',
            )}`}</label>
            <Input
              width="auto"
              placeholder=""
              name="adjudged_lose"
              value={configData.standing_point_config.adjudged_lose}
              onChange={handleStandingPointOnChange}
            />
          </div>
          <div className="input-field" />
          <div className="error-msg">{errorMsg}</div>
          <div className="success-msg">{successMsg}</div>
          <Button width="unset" color="red" nowrap type="submit">
            {Multilingual('COMMON.UPDATE')}
          </Button>
        </div>
      </StyledForm>
    </SectionDiv>
  );
};

export default Stats;
